module.exports = __webpack_public_path__ + "img/account.9a9b42c4.gif";